<style media="screen">

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        padding-top: 71px;
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    input[type=file] {
        display: none;
    }

</style>

<template>

    <el-row>
        <el-form :model="iconForm" :rules="rules" addAction="icon/addIconCarCircle.action" editAction="icon/addIconCarCircle.action"
                 label-width="100px" ref="iconForm" selectAction="icon/selectIconCarCircle.action" v-form>
            <h3>
                编辑icon导航
            </h3>
            <el-col :span="18" class="basic-margin">

                <el-form-item label="icon名称" label-position="left" prop="name">
                    <el-input placeholder="请输入icon名称" v-model="iconForm.name">
                    </el-input>
                </el-form-item>

                <el-form-item label="排序值" label-position="left" prop="sort">
                    <el-input type="number"  v-model="iconForm.sort" placeholder="请输入整数"></el-input>
                </el-form-item>

                <el-form-item label="icon图片" label-position="top" prop="img">
                    <el-upload  :before-upload="beforeAvatarUpload" :action="baseUrl+'upload/uploadPic'" :data="{floder:'icon'}" :show-file-list="false"
                               accept="image/*" class="avatar-uploader" v-model="iconForm.img">
                        <img width="83px" height="83px" :src="iconForm.img.url" class="avatar" v-if="iconForm.img">
                        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    </el-upload>
                </el-form-item>

                <el-form-item class="basic-margin">
                    <el-button type="primary">保存</el-button>
                    <el-button @click="back()">取消</el-button>
                </el-form-item>
            </el-col>
        </el-form>

    </el-row>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  name: 'save-car-circle-dialog',
  extends: BasicPager,
  data: function () {
    return {
      checkAll: false,
      visible: false,
      imageUrl: '',
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      iconForm: {
        id: null,
        name: '',
        channelId: null,
        img: null,
        sort: null
      },
      rules: {
        name: [{
          required: true,
          message: 'icon名称不能为空',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'blur'
        }],
        img: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '请输入排序值',
          trigger: 'change'
        }]
      }
    }
  },
  created: function () {
    // 获取参数
    let params = this.$route.params
    if (params) {
      this.iconForm.id = params.id
    }
    let loginInfo = this.loginInfo
    this.iconForm.channelId = loginInfo.id
  },
  methods: {
    beforeAvatarUpload: function (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt2M = file.size / 1024 < 150
        if (!isLt2M) {
          _this.$message.error('上传头像图片大小不能超过 150 KB!')
          reject()
          return
        }
        var isAllow = false
        var reader = new FileReader()
        reader.onload = function (e) {
          var data = e.target.result
          // 加载图片获取图片真实宽度和高度
          var image = new Image()
          image.onload = function () {
            var width = image.width
            var height = image.height

            if (width == 83 && height == 83) {
              resolve()
            } else {
              _this.$message({
                type: 'error',
                message: '图片必须等于83px*83px'
              })
              reject()
            }
          }
          image.src = data
        }
        reader.readAsDataURL(file)
      })
      return promise
    },
    back: function () {
      this.$router.back(-1)
    }
  }
}

</script>
